import { ButtonLinkVariant } from '@kanda-libs/ks-design-library';

export type Destination = 'dashboard' | 'subscription' | 'contract';

export const SEARCH_OPTIONS = {
  keys: [
    { name: 'firstName', weight: 1 },
    { name: 'lastName', weight: 1 },
    { name: 'name', weight: 1 },
    { name: 'email', weight: 1 },
    { name: 'mobile', weight: 1 },
    { name: 'company', weight: 1 },
  ],
  includeMatches: true,
  matchAllOnEmptyQuery: true,
  minMatchCharLength: 4,
  threshold: 0.2,
  distance: 1000,
  ignoreLocation: true,
};

export const USER_MODAL_ID = 'user-modal';

export const DESTINATION_SELECT_PROPS = {
  name: 'destination',
  label: 'Login destination',
  placeholder: 'Select...',
  options: [
    {
      name: 'dashboard',
      value: 'dashboard',
    },
    {
      name: 'subscription',
      value: 'subscription',
    },
    {
      name: 'contract',
      value: 'contract',
    },
    {
      name: 'premium credit enable',
      value: 'premium_credit_enable',
    },
    {
      name: 'premium credit disable',
      value: 'premium_credit_disable',
    },
  ],
};

export const DESTINATION_SELECT_VALIDATION = {
  required: {
    value: true,
    message: 'Destination is required',
  },
};

export const COPY_BUTTON_PROPS = {
  id: 'user-login-code-copy-button',
  icon: 'copy',
  variant: 'grey' as ButtonLinkVariant,
  size: 14,
  left: true,
  label: 'Copy URL',
};

export const COPIED_BUTTON_PROPS = {
  id: 'user-login-cod-copied-button',
  icon: 'check',
  variant: 'turquoise' as ButtonLinkVariant,
  size: 14,
  left: true,
  label: 'URL Copied',
};
